// src/common/components/serviceModeIndicator/ServiceModeIndicator.tsx
import React from "react";
import { useSelector } from "react-redux";
import {
  selectIsExecutor,
  selectIsAdmin,
  selectClientUserId,
} from "../../../store/slices/executorSlice";
import classes from "./ServiceModeIndicator.module.scss";

export const ServiceModeIndicator = () => {
  const isExecutor = useSelector(selectIsExecutor);
  const isAdmin = useSelector(selectIsAdmin);
  const clientUserId = useSelector(selectClientUserId);

  if (!isExecutor && !isAdmin) return null;

  const mode = clientUserId
    ? `ОБСЛУЖИВАНИЕ КЛИЕНТА #${clientUserId}`
    : isAdmin
      ? "РЕЖИМ АДМИНИСТРАТОРА"
      : "РЕЖИМ МЕНЕДЖЕРА ПО ПРОДАЖАМ";

  return (
    <div
      className={`${classes.indicator} ${
        clientUserId ? classes.clientMode : classes.managerMode
      }`}
    >
      <div className={classes.textWrapper}>{mode}</div>
    </div>
  );
};
